import { Component, OnInit } from '@angular/core';
import { LoadingService } from './loading.service';
/**
 * loading component
 */
@Component({
  selector: 'app-app-loading',
  templateUrl: './app-loading.component.html',
  styleUrls: ['./app-loading.component.scss']
})
export class AppLoadingComponent implements OnInit {
  /**
   * indicate if loading is being performed
   */
  isLoading;

  /**
   * message to be displayed for end user
   */
  loadMessage;

  /**
   * indicate if loading is for component or page
   */
  isComponent;

  /**
   * constructor to inject dependency
   * @param loadingService instance of loadingService
   */
  constructor(private loadingService: LoadingService) {}

  /**
   * initialize component
   */
  ngOnInit() {
    this.loadingService.loader.subscribe(loading => {
      this.isLoading = loading.showLoading;
      this.loadMessage = loading.loadingMessage;
      this.isComponent = loading.isComponent;
    });
  }
}
